<div class="container" [class.active]="!!value" (click)="toggle()">
  <div class="circle">
    <stusan-icon [icon]="icon" *ngIf="icon"></stusan-icon>
  </div>
</div>
